import React, {ChangeEvent, KeyboardEventHandler, useEffect, useState} from "react";
import {Input} from "../../../ui-components/Input/Input";
import {ValidationErrorText} from "../../../ui-components/ValidationErrorText/ValidationErrorText";

interface ZipCodeInputProps {
    zipCode: string;
    onSetZipCode: (zipCode: string) => void;
    onSetZipCodeValid: (isZipCodeValid: boolean) => void;
}

export const ZipCodeInput: React.FunctionComponent<ZipCodeInputProps> = (props) => {
    const [errors, setErrors] = useState<string[]>([]);
    const [isValid, setIsValid] = useState<boolean>(false);
    const requiredCvvError = 'Zip Code is a required field.';

    useEffect(() => {
        props.onSetZipCodeValid(isValid);
    }, [isValid]);

    const onChange = (event: ChangeEvent) => {
        const zipCode = (event.target as HTMLInputElement).value;
        props.onSetZipCode(zipCode);
        validateZipCode(zipCode);
    }

    const onBlur = (event: React.FocusEvent<HTMLInputElement>) => {
        validateZipCode();
    }

    const validateZipCode = (zipCode: string = '') => {
        zipCode = zipCode || props.zipCode;
        let errorsTemp: string[] = [];
        if (zipCode === '') {
            errorsTemp.push(requiredCvvError);
        }
        setErrors(errorsTemp);
        setIsValid(errorsTemp.length === 0);
    }

    return <div>
        <Input isValid={isValid} type='text' required={true} value={props.zipCode} onChange={onChange}
               onBlur={onBlur}/>
        {errors.map((error: string) => {
            return <ValidationErrorText key={error} text={error}/>
        })}
    </div>
}
